module.exports = __webpack_public_path__ + "media/add_exercise.acca21c6.mp4";